import React, { Component } from "react";
import { FormValidate } from "../../../../../components/formValidate";
import CustomButton from "../../../../../components/inputs/button";
import TextField from "../../../../../components/inputs/textfield";
import Loader from "../../../../../components/loader/loader";
import Snackbar from "../../../../../components/snackbar/snackbar";
import { admin_banner_add } from "../../../admin.api";
import "./dialog.css";

let required = []; // Remove banner_image from required fields - handle manually
class Dialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      formData: props.formData,
      edit: props.edit,
      submitted: false,
      snackMessage: "",
      isActive: false,
      fileChanged: false,
      isSnackError: false,
      snackOpen: false,
    };
  }

  componentWillReceiveProps = (props) => {
    this.setState({
      open: props.open,
      edit: props.edit,
      formData: props.formData,
    });
  };
  handleChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    let type = e.target.type;

    // Apply special character prevention only to text input fields (not file inputs)
    if (type === 'text' || type === undefined || type === null) {
      // Allow only letters, numbers, and spaces (no special characters)
      const allowedPattern = /^[a-zA-Z0-9\s]*$/;
      
      if (!allowedPattern.test(value)) {
        // Remove all special characters, keep only letters, numbers, and spaces
        const cleanValue = value.replace(/[^a-zA-Z0-9\s]/g, '');
        e.target.value = cleanValue;
        this.setState({ formData: { ...this.state.formData, [name]: cleanValue } });
        return;
      }
    }

    this.setState({ formData: { ...this.state.formData, [name]: value } });
  };

  handleKeyDown = (e) => {
    let type = e.target.type;
    
    // Apply special character prevention only to text input fields (not file inputs)
    if (type === 'text' || type === undefined || type === null) {
      // Allow only letters, numbers, and spaces (no special characters)
      const allowedPattern = /^[a-zA-Z0-9\s]$/;
      const char = e.key;
      
      // Allow control keys (backspace, delete, arrow keys, etc.)
      if (e.ctrlKey || e.metaKey || e.altKey) {
        return;
      }
      
      // Allow navigation keys
      if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Tab'].includes(char)) {
        return;
      }
      
      // Prevent all special characters
      if (!allowedPattern.test(char)) {
        e.preventDefault();
        return false;
      }
    }
  };
  snackbarClose = (flag) => {
    this.setState({
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
    });
    if (!flag) {
      this.props.handleClose();
    }
  };
  handleSubmit = (e) => {
    const error = FormValidate(this.state.formData, required);
    const { edit, formData } = this.state;
    e.preventDefault();

    // Manual validation for banner image
    const hasBannerImage = formData.banner_image && 
                          (formData.banner_image instanceof File || 
                           typeof formData.banner_image === 'string' && formData.banner_image !== '');
    
    // For new submissions (not edit), banner image is required
    const bannerImageError = !edit && !hasBannerImage;

    // Allow submission if:
    // 1. It's an edit operation (banner image not required), OR
    // 2. It's a new submission with banner image provided, OR
    // 3. All required fields are filled (currently none)
    if ((edit && Object.keys(error).length === 0) || 
        (!edit && hasBannerImage && Object.keys(error).length === 0)) {
      this.setState({ isActive: true });
      const form = new FormData();
      if (formData.banner_location_text_ma)
        form.append(
          "banner_location_text_ma",
          formData.banner_location_text_ma
        );
      if (formData.banner_location_text_en)
        form.append(
          "banner_location_text_en",
          formData.banner_location_text_en
        );
      if (formData.banner_main_text_en)
        form.append("banner_main_text_en", formData.banner_main_text_en);
      if (formData.banner_main_text_ma)
        form.append("banner_main_text_ma", formData.banner_main_text_ma);

      if (formData.banner_highlight_text_en)
        form.append(
          "banner_highlight_text_en",
          formData.banner_highlight_text_en
        );
      if (formData.banner_highlight_text_ma)
        form.append(
          "banner_highlight_text_ma",
          formData.banner_highlight_text_ma
        );

      if (edit) {
        if (this.state.fileChanged) {
          form.append("banner_image", formData.banner_image);
        }
      } else {
        form.append("banner_image", formData.banner_image);
      }
      if (formData.id) form.append("banner_id", formData.id);

      admin_banner_add(form, edit ? formData.uuid : null)
        .then((res) => {
          this.setState({
            submitted: true,
            isActive: false,
            snackMessage: res.message,
            isSnackError: false,
            snackOpen: true,
          });
        })
        .catch((error) => {
          this.setState({
            submitted: false,
            snackMessage: error.message,
            isSnackError: true,
            isActive: false,
            snackOpen: true,
          });
        });
    } else {
      this.setState({
        submitted: false,
        snackMessage: bannerImageError ? "Please select a banner image" : "Please fill all mandatory fields",
        isSnackError: true,
        snackOpen: true,
      });
    }
  };
  handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    const type = String(file?.name || "").split(".").pop();

    // Since the name might be undefined, hardcode it to banner_image
    const fieldName = "banner_image";

    const validImageTypes = ["png", "jpeg", "jpg"];
    const validVideoTypes = ["mp4", "mov", "webm", "mkv", "avi"];

    if (type && validVideoTypes.includes(type.toLowerCase())) {
      this.setState({
        fileChanged: true,
        formData: {
          ...this.state.formData,
          [fieldName]: file,
        },
      });
    } else if (type && validImageTypes.includes(type.toLowerCase())) {
      let flag = false;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        var image = new Image();
        image.src = e.target.result;

        image.onload = () => {
          var height = image.height;
          var width = image.width;

          if (height === 940 && width === 1920) {
            flag = true;
          }
          
          setTimeout(() => {
            if (flag) {
              this.setState({
                fileChanged: true,
                formData: {
                  ...this.state.formData,
                  [fieldName]: file,
                },
              });
            } else {
              this.setState({
                snackMessage: "Image dimension should be width=1920, height=940",
                isSnackError: true,
                snackOpen: true,
              });
            }
          }, 200);
        };
      };
    } else {
      this.setState({
        snackMessage:
          "File should be an image (.jpg, .jpeg, .png) or video (.mp4, .mov, .webm, .mkv, .avi)",
        isSnackError: true,
        snackOpen: true,
      });
    }
  };
  render() {
    const { submitted, formData, open, edit, isActive } = this.state;
    const { view } = this.props;
    //
    return (
      <React.Fragment>
        {open && (
          <React.Fragment>
            <div className="overlay">
              <Loader open={isActive} />
              <div className="big-dia dialog">
                <Snackbar
                  message={this.state.snackMessage}
                  error={this.state.isSnackError}
                  open={this.state.snackOpen}
                  close={this.snackbarClose}
                />
                <div className="row">
                  <div className="flexDisplay">
                    <div className="diaTitleCon">
                      {edit ? "Edit Banner" : view ? "Banner" : "Add Banner"}
                    </div>
                    <div className="dia-close" onClick={this.props.handleClose}>
                      <div className="diaCloseCon">
                        <div className="diaClose">&#10005;</div>
                      </div>
                    </div>
                  </div>
                  <div className="tilebar d-flex justify-content-start">
                    <hr />
                  </div>
                  <form action="">
                    <div className="book-form">
                      {/* <div className="content-scroll"> */}
                        <div className="col-12">
                          <TextField
                            id="outlined-basic"
                            disabled={view}
                            label="Heading [Eng]"
                            variant="outlined"
                            onChange={(e) => this.handleChange(e)}
                            onKeyDown={(e) => this.handleKeyDown(e)}
                            value={formData.banner_main_text_en ?? ""}
                            name="banner_main_text_en"
                          // required
                          />
                        </div>
                        <div className="col-12">
                          <TextField
                            id="outlined-basic"
                            label="Heading [Mal]"
                            disabled={view}
                            variant="outlined"
                            onChange={(e) => this.handleChange(e)}
                            onKeyDown={(e) => this.handleKeyDown(e)}
                            value={formData.banner_main_text_ma ?? ""}
                            name="banner_main_text_ma"
                          // required
                          />
                        </div>
                        <div className="col-12 not-required">
                          <TextField
                            id="outlined-basic"
                            name="banner_highlight_text_en"
                            onChange={(e) => this.handleChange(e)}
                            onKeyDown={(e) => this.handleKeyDown(e)}
                            // multiline
                            disabled={view}
                            label="Highlight Text [Eng]"
                            value={formData.banner_highlight_text_en ?? ""}
                            variant="outlined"
                          // required
                          />
                        </div>
                        <div className="col-12 not-required">
                          <TextField
                            id="outlined-basic"
                            onChange={(e) => this.handleChange(e)}
                            onKeyDown={(e) => this.handleKeyDown(e)}
                            value={formData.banner_highlight_text_ma ?? ""}
                            // multiline
                            disabled={view}
                            label="Highlight Text [Mal]"
                            name="banner_highlight_text_ma"
                            variant="outlined"
                          // required
                          />
                        </div>
                        <div className="col-12 not-required">
                          <TextField
                            id="outlined-basic"
                            label="Location [Eng]"
                            disabled={view}
                            variant="outlined"
                            onChange={(e) => this.handleChange(e)}
                            onKeyDown={(e) => this.handleKeyDown(e)}
                            value={formData.banner_location_text_en ?? ""}
                            name="banner_location_text_en"
                          // required
                          />
                        </div>
                        <div className="col-12 not-required">
                          <TextField
                            id="outlined-basic"
                            label="Location [Mal]"
                            disabled={view}
                            variant="outlined"
                            onChange={(e) => this.handleChange(e)}
                            onKeyDown={(e) => this.handleKeyDown(e)}
                            value={formData.banner_location_text_ma ?? ""}
                            name="banner_location_text_ma"
                          // required
                          />
                        </div>
                        <div className="col-12">
                          <TextField
                            id="outlined-basic"
                            label="Image/Video(Dimension:width=1920px,height=940px) (Image: .jpg, .jpeg, .png | Video: .mp4, .mov, .webm, .mkv, .avi)"
                            accept=".jpg,.jpeg,.png,.mp4,.mov,.webm,.mkv,.avi"
                            // label="Image(Dimension:width=1920px,height=940px format= .jpg , .jpeg ,.png)"
                            // accept=".jpg ,.jpeg,.png"
                            name="banner_image"
                            disabled={view}
                            type="file"
                            variant="outlined"
                            fileName={
                              formData?.banner_image instanceof File
                                ? formData?.banner_image?.name
                                : formData?.banner_image
                            }
                            onChange={this.handleFileChange}
                            required
                          />
                        </div>
                      {/* </div> */}
                      {!view && (
                        <div className="col-12">
                          <CustomButton
                            label={edit ? "Update" : "Add"}
                            disabled={submitted}
                            onClick={(e) => this.handleSubmit(e)}
                          />
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default Dialog;
